<!-- display list of objects only when they are more than one -->
@if (objects.length > 1) {
  <div class="object-list">
    <app-dataobject-list-simple
      [objects]="objects"
    ></app-dataobject-list-simple>
  </div>
}

<!-- Ownership: pending change is saved with the dialog's main save -->
@if (canChangeOwner && currentOwner) {
  <div class="ownership-section">
    <h5>{{ "object-permissions.title.ownership" | translate }}</h5>
    <div class="owner-cards">
      <div class="owner-block">
        <span class="owner-label">
          {{ "object-ownership.title.current-owner" | translate }}
        </span>
        <app-principal-card [principal]="currentOwner"></app-principal-card>
      </div>
      @if (pendingOwner) {
        <div class="owner-block">
          <span class="owner-label">
            {{ "object-permissions.title.new-owner" | translate }}
          </span>
          <app-principal-card [principal]="pendingOwner"></app-principal-card>
        </div>
      }
    </div>
    @if (pendingOwner) {
      <div class="owner-options">
        <sui-checkbox [formControl]="ownerControls.applyToChildObjects">
          {{
            "object-ownership.label.change-owner-to-child-objects" | translate
          }}
        </sui-checkbox>
        <sui-checkbox
          [formControl]="ownerControls.applyToSameOwnerChildObjectsOnly"
        >
          {{
            "object-ownership.label.change-owner-to-child-objects-with-same-owner-only"
              | translate
          }}
        </sui-checkbox>
        <span class="owner-hint">
          {{
            "object-permissions.msg.ownership-transfer-is-applied-on-save"
              | translate
          }}
        </span>
      </div>
    }
    <div class="owner-actions">
      <sui-button variant="secondary" size="sm" (click)="onSelectNewOwner()">
        {{ "object-ownership.button.select-new-owner" | translate }}
      </sui-button>
      @if (pendingOwner) {
        <sui-button variant="secondary" size="sm" (click)="clearPendingOwner()">
          {{ "object-permissions.button.keep-current-owner" | translate }}
        </sui-button>
      }
    </div>
  </div>
}

<!-- Tabs -->

@if (visibleTabs.length) {
  <ul class="nav nav-tabs">
    @for (tab of visibleTabs; track tab) {
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{ active: builderType === tab.key }"
          (click)="changeBuilderType(tab.key)"
          role="button"
        >
          @if (tab.icon) {
            <fa-icon [icon]="tab.icon" class="me-2"></fa-icon>
          }
          {{ tab.label | translate }}
        </a>
      </li>
    }
  </ul>
}

@if (builderType === "simple") {
  <app-object-permissions-simple
    [principals]="principals()"
    [formGroup]="formGroup"
    [permissions]="permissions()"
    [permissionRoleList]="permissionRoleList"
    [NomObjectPermission]="NomObjectPermission"
    (removePrincipalRequested)="onRemovePrincipal($event)"
    (addPrincipalsRequested)="onAddPrincipalsRequest()"
    (principalRoleChange)="onPrincipalRoleChange($event)"
  >
  </app-object-permissions-simple>
} @else {
  <app-object-permissions-advanced
    [permissions]="permissions()"
    [formGroup]="formGroup"
    [principals]="principals()"
    [loading]="loading()"
    [NomObjectPermission]="NomObjectPermission"
    (removePrincipalRequested)="onRemovePrincipal($event)"
    (addPrincipalsRequested)="onAddPrincipalsRequest()"
    (permissionToggle)="onPermissionToggle($event)"
    (toggleAllForPrincipal)="onToggleAllForPrincipal($event)"
  >
  </app-object-permissions-advanced>
}
